<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
	background-color: #419FFF;
	border-radius: 2px;
}
</style>

<template>
	<div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:4px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{ $t('liangtaijikaijilv') }}
				</p>
			</div>

		</div>
		<div id="xiangjiaoMonitorKaijilvchart" :style="{ 'height': chartHeight + 'px' }">


		</div>

	</div>

</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_efficiency_all',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			timer: null,
			chart: null,
			option: null,
			chartHeight: 0,
		};
	},
	created() {
		this.timer = setInterval(() => {
			this.makeData()
		}, 600000)
	},

	watch: {
		datas: {
			handler(n, o) {
				if (n != o) {
					this.makeData()
				}
			},
			deep: true
		}
	},
	activated() {
		this.resize()
	},
	mounted() {
		this.resize()
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.makeData()

	},


	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	},
	methods: {
		makeData() {
			this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
				20
			if (!this.chart) {
				setTimeout(() => {
					this.initChart()
					this.makeData()
				}, 100)
			} else {



				let dates = Object.keys(this.datas["YL2-H300F"].startupRateMap)
				//dates年月日从小到大排序
				dates.sort((a, b) => {
					let aDate = new Date(a)
					let bDate = new Date(b)
					return aDate - bDate
				})
				let startupRates1 = []
				let startupRates2 = []
				let startupTime1 = []
				let startupTime2 = []
				//dates只取2025-10-08和之后的
				dates = dates.filter(item => item >= "2025-10-08")

				dates.forEach(item => {
					startupTime1.push(this.datas["YL2-H300F"].startUpMap[item])
					startupTime2.push(this.datas["YL3-V440F"].startUpMap[item])
					startupRates1.push(this.datas["YL2-H300F"].startupRateMap[item])
					startupRates2.push(this.datas["YL3-V440F"].startupRateMap[item])
				})

				//只取日
				dates = dates.map(item => {
					console.log(item)
					let m = item.split("-")[1]
					let d = item.split("-")[2]
					if (m[0] == '0') {
						m = m[1]
					}
					if (d[0] == '0') {
						d = d[1]
					}

					return m + "/" + d
				})
				let size = dates.length

				//保留两位小数
				startupTime1 = startupTime1.map(item => {
					if (item > 9) {
						item = 9
					}
					return item.toFixed(2)
				})
				startupTime2 = startupTime2.map(item => {
					if (item > 9) {
						item = 9
					}
					return item.toFixed(2)
				})
				startupRates1 = startupTime1.map(item => (parseFloat(item) / 9 * 100).toFixed(2))
				startupRates2 = startupTime2.map(item => (parseFloat(item) / 9 * 100).toFixed(2))


				//去掉%，x100，保留两位小数
				// startupRates1 = startupRates1.map(item => parseFloat(item.replace("%", ""))).map(item => item.toFixed(2))
				// startupRates2 = startupRates2.map(item => parseFloat(item.replace("%", ""))).map(item => item.toFixed(2))

				//startupTime1,startupTime2,startupRates1,startupRates2，都只取最后size个
				startupTime1 = startupTime1.slice(-size)
				startupTime2 = startupTime2.slice(-size)
				startupRates1 = startupRates1.slice(-size)
				startupRates2 = startupRates2.slice(-size)



				let sumKaijishijian = startupTime1.reduce((a, b) => parseFloat(a) + parseFloat(b), 0) + startupTime2.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
				this.utils.event_hub.$emit('xiangjiaoSumKaijishijian', sumKaijishijian.toFixed(1), ((sumKaijishijian / (9 * size * 2)) * 100).toFixed(2))


				this.option.xAxis.data = dates;
				this.option.series[0].data = startupTime1;
				this.option.series[1].data = startupTime2;
				this.option.series[2].data = startupRates1;
				this.option.series[3].data = startupRates2;
				this.chart.setOption(this.option)
			}

		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.titleBar) {
					return;
				}
				this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
					20
				if (!this.chart) {
					return;
				}
				this.chart.getDom().style.height = this.chartHeight + "px";
				this.chart.resize()

			}, 800)
		},
		initChart() {
			this.option = {
				backgroundColor: null,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						label: {
							formatter: '{value} '
						},
						// 坐标轴指示器，坐标轴触发有效
						type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
					},
					backgroundColor: 'rgba(0,0,0,0.8)',
					borderWidth: 0,
					textStyle: {
						color: "#C0C4CC",
					},
					formatter: function (params) {
						let result = params[0].name + '<br/>';
						params.forEach(function (item) {
							if (item.seriesIndex === 2 || item.seriesIndex === 3) {
								// 折线图数据添加%符号
								result += item.marker + item.seriesName + ': ' + item.value + '%<br/>';
							} else {
								// 柱状图数据保持原样
								result += item.marker + item.seriesName + ': ' + item.value + ' h<br/>';
							}
						});
						return result;
					}
				},
				grid: {
					left: '0',
					right: '0',
					bottom: '0',
					top: '30',
					containLabel: true,
				},
				legend: {
					left: 'center',
					top: '0%',
					textStyle: {
						color: '#FFFFFF',
						fontSize: 12,
					},
					itemWidth: 15,
					itemHeight: 10,
					itemGap: 25,
				},
				dataZoom: [{
					show: false,
					height: 8,
					xAxisIndex: [0],
					bottom: 0,
					start: 0,
					end: 100,
					handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
					handleSize: '100%',
					handleStyle: {
						color: 'rgba(255, 255, 255,1',
					},
					textStyle: {
						color: "transparent",
						fontSize: 12,
					},
					fillerColor: '#CBCED4',
					borderColor: 'transparent',
					backgroundColor: 'transparent',
					showDataShadow: false,
					brushSelect: false,
				},
				{
					type: 'inside',
					disabled: false,
				},
				],
				xAxis: {
					show: true,
					type: 'category',
					name: '',
					nameLocation: 'end',
					nameTextStyle: {
						fontSize: 12,
					},
					inverse: false,
					splitLine: {
						show: false,
						lineStyle: {
							type: 'dashed',
							color: '#000',
							width: 1,
						},
					},
					axisTick: {
						show: true,
						alignWithLabel: false,
						interval: 'auto',
						inside: false,
						length: 5,
						lineStyle: {
							type: 'solid',
							width: 1,
							color: '#909399',
						},
					},
					axisLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							width: 1,
							color: '#909399',
						},
					},
					axisLabel: {
						margin: 8,
						interval: 'auto',
						rotate: 0,
						fontSize: 12,
						color: '#C0C4CC',
					},
					data: [],
				},
				yAxis: [{
					show: true,
					type: 'value',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value} h',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}, {
					show: true,
					type: 'value',
					position: 'right',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value} %',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}],
				series: [{
					name: this.$t('YL2-H300F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FD9DFF',
							},
							{
								offset: 1,
								color: '#4F32FF',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				},
				{
					name: this.$t('YL3-V440F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#6FE5FF',
							},
							{
								offset: 1,
								color: '#1C70C6',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#419FFF',
						position: 'top',
						fontSize: 12,
					},
					// data: this.efficiencies.startupRates,
					data: [],
					// runRate

				},
				{
					name: this.$t('YL2-H300F'),
					yAxisIndex: 1,
					type: 'line',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FD9DFF',
							},
							{
								offset: 1,
								color: '#4F32FF',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				},
				{
					name: this.$t('YL3-V440F'),
					yAxisIndex: 1,
					type: 'line',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#6FE5FF',
							},
							{
								offset: 1,
								color: '#1C70C6',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#419FFF',
						position: 'top',
						fontSize: 12,
					},
					// data: this.efficiencies.startupRates,
					data: [],
					// runRate

				},
				],


			};
			var chartDom = document.getElementById('xiangjiaoMonitorKaijilvchart');
			this.chart = this.echarts.init(chartDom);
			this.option && this.chart.setOption(this.option);
		}
	}
};
</script>
